export default __webpack_public_path__ + "static/media/essam.f703e9a1.png";